import React from 'react'
import OnClickPipeline from 'support/pipelines/OnClickPipeline'
import ToggleAccordionOnPipe from 'support/utilities/accordions/pipes/ToggleAccordionOnPipe'

export default function ToggleAccordionOnClickPipeline ({ name, children, pipes }) {
  return (
    <OnClickPipeline trigger={children}>
      {pipes}
      <ToggleAccordionOnPipe name={name} />
    </OnClickPipeline>
  )
}
